"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pink = void 0;
exports.pink = {
    c10: '#4E0627',
    c20: '#74103E',
    c30: '#9D1756',
    c40: '#C8206F',
    c50: '#E62881',
    c60: '#F65495',
    c70: '#F888AE',
    c80: '#FBC7D5',
    c90: '#FEECF1',
    c100: '#FFFFFF',
};
//# sourceMappingURL=pink.js.map